import React from 'react'
import { useToken } from '../hooks'

const BANNEDPage = ({ redirect = '' }) => {
	const { mutate } = useToken()
	mutate(null)
	return <>BANNED</>
}

export default React.memo(BANNEDPage)
